import { TransactionsPairForReconciliation } from "@common/contracts/reconciliation.contract";
import { determineFinancialTransactionDateAfterReconciliation } from "@common/helpers/reconciliation";

export interface MatchedTransactionDate {
    financialTransactionId: number;
    newDate?: string;
    clearedDate?: string;
}

export interface GetMatchedTransactionDatesParams {
    pairs: TransactionsPairForReconciliation[];
    financialTransactionIdsIgnoringDateChanges: number[];
}

export function getMatchedTransactionDates({
    pairs,
    financialTransactionIdsIgnoringDateChanges,
}: GetMatchedTransactionDatesParams): MatchedTransactionDate[] {
    return pairs.flatMap(({ fromAccount, fromStatement }) => {
        if (
            !fromAccount ||
            !fromStatement ||
            !fromAccount.financialTransactionId ||
            !fromAccount.date
        ) {
            return [];
        }
        const finalDate = determineFinancialTransactionDateAfterReconciliation(
            fromAccount,
            fromStatement,
            financialTransactionIdsIgnoringDateChanges,
        );
        return [
            {
                financialTransactionId: fromAccount.financialTransactionId,
                newDate: finalDate !== fromAccount.date ? finalDate : undefined,
                clearedDate: fromAccount.isCashItem
                    ? fromStatement.date
                    : undefined,
            },
        ];
    });
}
